<script setup lang="ts">
import { ref, watch } from "vue"

import DeleteConfirmModal from "@/components/DeleteConfirmModal.vue"
import { ICON } from "@/lib/icons"

const props = defineProps<{
  open: boolean
  itemName: string
  quantity: number
  loading?: boolean
}>()

const emit = defineEmits<{
  "update:open": [value: boolean]
  confirm: [data: { name: string; asset_code: string; reduce_quantity: boolean }]
}>()

const name = ref("")
const assetCode = ref("")
const reduceQuantity = ref(false)

watch(
  () => props.open,
  (open) => {
    if (open) {
      name.value = `${props.itemName} (copy)`
      assetCode.value = ""
      reduceQuantity.value = false
    }
  },
)
</script>

<template>
  <DeleteConfirmModal
    :open="open"
    :title="`Duplicate ${itemName}`"
    :loading="loading"
    :disabled="!name.trim()"
    action-label="Duplicate"
    action-color="primary"
    :action-icon="ICON.duplicate"
    @update:open="emit('update:open', $event)"
    @confirm="
      emit('confirm', {
        name: name.trim(),
        asset_code: assetCode.trim(),
        reduce_quantity: reduceQuantity,
      })
    "
  >
    <div class="flex flex-col gap-4">
      <p class="text-muted text-sm">
        Creates a copy with the same description, type, location, and photos.
      </p>

      <UFormField label="Name" required>
        <UInput v-model="name" autofocus class="w-full" />
      </UFormField>

      <UFormField label="Asset Code">
        <UInput
          v-model="assetCode"
          placeholder="Auto-generated if blank"
          class="w-full font-mono"
        />
      </UFormField>

      <div v-if="quantity > 1" class="flex items-center gap-2">
        <USwitch v-model="reduceQuantity" />
        <span class="text-sm">Reduce original quantity by 1 (currently {{ quantity }})</span>
      </div>
    </div>
  </DeleteConfirmModal>
</template>
